// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"644ac605","811":"8cd852b7","879":"eef13e6c","909":"071e0e54"}[chunkId] + ".chunk.js";
};